export enum EDocumentType {
    AreaMap,
    PortFolio,
    Archive,

    // PDRE is a specific type of document that can only have one file uploaded, so we need to handle it separately in the UI.
    PDRE
}
